import React from "react";

const AgentSettings = () => {
  return <div>Agent Settings</div>;
};

export default AgentSettings;
